/**
 * Pure constants for the web-push permission banner's sessionStorage keys.
 *
 * Kept in their own side-effect-free module (no React/CSS imports) so pure
 * helpers such as webPushBannerVisibility can consume them without coupling to
 * the WebPushPermissionBanner component (which imports CSS). The component
 * re-exports these for back-compat with existing importers.
 */
export const WEB_PUSH_LOGIN_PROMPT_KEY = "compasscare_web_push_login_prompt";

/** Session-only dismiss for "Not now" — does not block re-prompt on next login. */
export const WEB_PUSH_BANNER_DISMISSED_KEY =
  "compasscare_web_push_banner_dismissed";
